'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var cx = _interopDefault(require('classnames'));
var Popover = _interopDefault(require('@arrive/popover'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","arrow":"arrive_Tooltip__arrow","container":"arrive_Tooltip__container"};

function useCallbackRef(onMouseOver, onMouseOut) {
  var ref = React.useRef(null); // All of this ensures that the user can mouse onto the tooltip to interact with the text within

  var setRef = React.useCallback(function (node) {
    if (ref.current) {
      ref.current.removeEventListener('mouseenter', onMouseOver);
      ref.current.removeEventListener('mouseleave', onMouseOut);
    }

    if (node) {
      node.addEventListener('mouseenter', onMouseOver);
      node.addEventListener('mouseleave', onMouseOut);
    }

    ref.current = node;
  }, [onMouseOver, onMouseOut]);
  return [setRef];
}

var useDebouncedEffect = function useDebouncedEffect(effect, delay, deps) {
  var callback = React.useCallback(effect, deps);
  React.useEffect(function () {
    var handler = setTimeout(function () {
      callback();
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [callback, delay]);
};

function Tooltip(_ref) {
  var popperContent = _ref.popperContent,
      children = _ref.children,
      placement = _ref.placement,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 150 : _ref$delay,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      rest = _objectWithoutProperties(_ref, ["popperContent", "children", "placement", "delay", "classes"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPopover = _useState2[0],
      setShowPopover = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mousePresent = _useState4[0],
      setMousePresent = _useState4[1];

  var onMouseOut = function onMouseOut() {
    return setMousePresent(false);
  };

  var onMouseOver = function onMouseOver() {
    return setMousePresent(true);
  };

  var _useCallbackRef = useCallbackRef(onMouseOver, onMouseOut),
      _useCallbackRef2 = _slicedToArray(_useCallbackRef, 1),
      popoverRef = _useCallbackRef2[0];

  useDebouncedEffect(function () {
    setShowPopover(mousePresent);
  }, delay, [mousePresent, setShowPopover]);
  return /*#__PURE__*/React__default.createElement(Popover, _extends({
    useBodyScrollLock: false,
    placement: placement,
    showPopover: showPopover,
    setShowPopover: setShowPopover,
    popperContent: popperContent,
    resolvedClasses: _objectSpread2({}, classes, {
      arrowClass: cx(styles.arrow, classes.arrowClass),
      contentContainerClass: cx(styles.container, classes.contentContainerClass)
    }),
    offset: [0, 8],
    arrow: true,
    ref: popoverRef
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    onFocus: function onFocus() {
      return setShowPopover(true);
    },
    onBlur: function onBlur() {
      return setShowPopover(false);
    }
  }, children));
}
Tooltip.propTypes = {
  classes: PropTypes.shape({
    anchorClass: PropTypes.string,
    contentContainerClass: PropTypes.string,
    arrowClass: PropTypes.string
  }),

  /**
   * milliseconds delay on mouse over to show the tooltip
   */
  delay: PropTypes.number,

  /**
   * These are the same placements as Popover
   */
  placement: PropTypes.string,
  popperContent: PropTypes.node.isRequired,

  /**
   * This is the anchor
   */
  children: PropTypes.node.isRequired
};

module.exports = Tooltip;
